import RpcClass from "../../../../../server/RpcClass.js";

import yaml from "js-yaml"

import RpcNotFoundException from "../../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

import BusinessRecord from "../../../../../server/com/silkplm/engine/entities/BusinessRecord.js";
let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.model.plm.BudgetingPlannerPM';

import LocalDate from "../../../../../server/LocalDate.js";
import LocalDateTime from "../../../../../server/LocalDateTime.js";
import LocalTime from "../../../../../server/LocalTime.js";



class BudgetingPlannerPM extends BusinessRecord {

    /**
     *  @class BudgetingPlannerPM
     *  @alias module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM
     *  
     * */
    constructor(){
        super();

        /** @type {string}  */
        this.EID = null;
        /** @type {boolean}  */
        this.__archived = null;
        /** @type {number}  */
        this.__familyId = null;
        /** @type {boolean}  */
        this.__hidden = null;
        /** @type {number}  */
        this.__parent = null;
        /** @type {Date}  */
        this.__versionDate = null;
        /** @type {Object.<string, *>}  */
        this._translations = null;
        /** @type {string}  */
        this.baseProductId = null;
        /** @type {string}  */
        this.budgetingPlannerId = null;
        /** @type {string}  */
        this.categoryId = null;
        /** @type {string}  */
        this.colorVersionId = null;
        /** @type {string}  */
        this.currentSelectedRegion = null;
        /** @type {LocalDate}  */
        this.dateRequiredOnWarehouse = null;
        /** @type {string}  */
        this.defaultEAN = null;
        /** @type {string}  */
        this.id = null;
        /** @type {BigDecimal}  */
        this.marginIPPlanner = null;
        /** @type {BigDecimal}  */
        this.netPricePlanner = null;
        /** @type {string}  */
        this.notes = null;
        /** @type {BigDecimal}  */
        this.onlineMarginPlanner = null;
        /** @type {BigDecimal}  */
        this.onlinePurchaseValuePlanner = null;
        /** @type {number}  */
        this.onlineQuantity = null;
        /** @type {BigDecimal}  */
        this.onlineQuantityPlanner = null;
        /** @type {number}  */
        this.optimum2XL = null;
        /** @type {number}  */
        this.optimum3XL = null;
        /** @type {number}  */
        this.optimumL = null;
        /** @type {number}  */
        this.optimumM = null;
        /** @type {number}  */
        this.optimumS = null;
        /** @type {number}  */
        this.optimumXL = null;
        /** @type {string}  */
        this.planningId = null;
        /** @type {BigDecimal}  */
        this.pricePlanner = null;
        /** @type {string}  */
        this.productId = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.promotionalPrice = null;
        /** @type {BigDecimal}  */
        this.purchaseValuePlanner = null;
        /** @type {BigDecimal}  */
        this.purchaseValueTotalPlanner = null;
        /** @type {number}  */
        this.quantityPOS = null;
        /** @type {BigDecimal}  */
        this.quantityPlanner = null;
        /** @type {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}  */
        this.recordMetadata = null;
        /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
        this.retailPrice = null;
        /** @type {string}  */
        this.salonCategory = null;
        /** @type {string}  */
        this.seasonId = null;
        /** @type {BigDecimal}  */
        this.sellingValueOnlinePlanner = null;
        /** @type {BigDecimal}  */
        this.sellingValuePlanner = null;
        /** @type {BigDecimal}  */
        this.sellingValueTotalPlanner = null;
        /** @type {string}  */
        this.subSeasonId = null;
        /** @type {string}  */
        this.supplierId = null;
        /** @type {BigDecimal}  */
        this.totalQuantityPlanner = null;
        /** @type {number}  */
        this.version = null;

        if(window["SessionManager"]?.isLoggedIn()){
            const formConfig = window['FormsLoader']?.detectFormConfig(FULL_CLASS);
            for(const f of formConfig.fields){
                if(f.formDisabled){
                    continue;
                }
                if( f.defaultValue !== null) {
                    this[f.fieldName] = yaml.load(f.defaultValue);
                }
             }
        }
    }





    /** @type {BigDecimal}  */
    get planningIdCBM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['planningIdCBM'] : null, this.__metadata__['planningIdCBM']?.remoteType);
    }
    set planningIdCBM(val){
    }
    // fk: false

    /** @type {string}  */
    get productIdProductIdPM(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdPM'] : null, this.__metadata__['productIdProductIdPM']?.remoteType);
    }
    set productIdProductIdPM(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getProductIdProductIdPMLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'productIdProductIdPM',  allowRemote); //  false 
    }

    /** @returns {String} */
    getProductIdProductIdPMStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'productIdProductIdPM'); //  false 
    }

    /** @returns {Promise<ApplicationUser>} */
    getProductIdProductIdPMEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'productIdProductIdPM',  allowRemote); //  false 
    }

    /** @type {string}  */
    get budgetingPlannerIdPMResponsibleForTheGroup(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['budgetingPlannerIdPMResponsibleForTheGroup'] : null, this.__metadata__['budgetingPlannerIdPMResponsibleForTheGroup']?.remoteType);
    }
    set budgetingPlannerIdPMResponsibleForTheGroup(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getBudgetingPlannerIdPMResponsibleForTheGroupLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.users.ApplicationUser', 'budgetingPlannerIdPMResponsibleForTheGroup',  allowRemote); //  false 
    }

    /** @returns {String} */
    getBudgetingPlannerIdPMResponsibleForTheGroupStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.users.ApplicationUser', 'budgetingPlannerIdPMResponsibleForTheGroup'); //  false 
    }

    /** @returns {Promise<ApplicationUser>} */
    getBudgetingPlannerIdPMResponsibleForTheGroupEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.users.ApplicationUser', 'budgetingPlannerIdPMResponsibleForTheGroup',  allowRemote); //  false 
    }

    /** @type {string}  */
    get colorVersionIdColor(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['colorVersionIdColor'] : null, this.__metadata__['colorVersionIdColor']?.remoteType);
    }
    set colorVersionIdColor(val){
    }
    // fk: true
    /** @returns {Promise<String>} */
    getColorVersionIdColorLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorVersionIdColor',  allowRemote); //  false 
    }

    /** @returns {String} */
    getColorVersionIdColorStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.Colors', 'colorVersionIdColor'); //  false 
    }

    /** @returns {Promise<Colors>} */
    getColorVersionIdColorEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.Colors', 'colorVersionIdColor',  allowRemote); //  false 
    }

    /** @type {BigDecimal}  */
    get productIdProductIdDuty(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdDuty'] : null, this.__metadata__['productIdProductIdDuty']?.remoteType);
    }
    set productIdProductIdDuty(val){
    }
    // fk: false

    /** @type {module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery}  */
    get productIdProductIdGallery(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdGallery'] : null, this.__metadata__['productIdProductIdGallery']?.remoteType);
    }
    set productIdProductIdGallery(val){
    }
    // fk: false

    /** @type {module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]}  */
    get productIdProductIdMerchants(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdMerchants'] : null, this.__metadata__['productIdProductIdMerchants']?.remoteType);
    }
    set productIdProductIdMerchants(val){
    }
    // fk: false

    /** @type {string}  */
    get productIdProductIdName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdName'] : null, this.__metadata__['productIdProductIdName']?.remoteType);
    }
    set productIdProductIdName(val){
    }
    // fk: false

    /** @type {string}  */
    get productIdProductIdUnitName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdUnitName'] : null, this.__metadata__['productIdProductIdUnitName']?.remoteType);
    }
    set productIdProductIdUnitName(val){
    }
    // fk: false

    /** @type {number}  */
    get productIdProductIdNumberOfProduct(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdNumberOfProduct'] : null, this.__metadata__['productIdProductIdNumberOfProduct']?.remoteType);
    }
    set productIdProductIdNumberOfProduct(val){
    }
    // fk: false

    /** @type {number}  */
    get productIdProductIdQuantityInner(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdQuantityInner'] : null, this.__metadata__['productIdProductIdQuantityInner']?.remoteType);
    }
    set productIdProductIdQuantityInner(val){
    }
    // fk: false

    /** @type {number}  */
    get planningIdQuantityOuter(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['planningIdQuantityOuter'] : null, this.__metadata__['planningIdQuantityOuter']?.remoteType);
    }
    set planningIdQuantityOuter(val){
    }
    // fk: false

    /** @type {string}  */
    get supplierIdSupplierCode(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['supplierIdSupplierCode'] : null, this.__metadata__['supplierIdSupplierCode']?.remoteType);
    }
    set supplierIdSupplierCode(val){
    }
    // fk: false

    /** @type {string}  */
    get productIdProductIdSupplierProductId(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productIdProductIdSupplierProductId'] : null, this.__metadata__['productIdProductIdSupplierProductId']?.remoteType);
    }
    set productIdProductIdSupplierProductId(val){
    }
    // fk: false

    /** @type {string}  */
    get comment(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['comment'] : null, this.__metadata__['comment']?.remoteType);
    }
    set comment(val){
    }


    /** @type {BigDecimal}  */
    get margin(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['margin'] : null, this.__metadata__['margin']?.remoteType);
    }
    set margin(val){
    }


    /** @type {string}  */
    get merchantsComputed(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['merchantsComputed'] : null, this.__metadata__['merchantsComputed']?.remoteType);
    }
    set merchantsComputed(val){
    }


    /** @type {number}  */
    get modelColorQuantityPlan(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['modelColorQuantityPlan'] : null, this.__metadata__['modelColorQuantityPlan']?.remoteType);
    }
    set modelColorQuantityPlan(val){
    }


    /** @type {number}  */
    get modelColorQuantityRealization(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['modelColorQuantityRealization'] : null, this.__metadata__['modelColorQuantityRealization']?.remoteType);
    }
    set modelColorQuantityRealization(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get netPrice(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['netPrice'] : null, this.__metadata__['netPrice']?.remoteType);
    }
    set netPrice(val){
    }


    /** @type {BigDecimal}  */
    get netPricePLNWithTransport(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['netPricePLNWithTransport'] : null, this.__metadata__['netPricePLNWithTransport']?.remoteType);
    }
    set netPricePLNWithTransport(val){
    }


    /** @type {BigDecimal}  */
    get numberOfOuters(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['numberOfOuters'] : null, this.__metadata__['numberOfOuters']?.remoteType);
    }
    set numberOfOuters(val){
    }


    /** @type {BigDecimal}  */
    get onlinePurchaseValue(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['onlinePurchaseValue'] : null, this.__metadata__['onlinePurchaseValue']?.remoteType);
    }
    set onlinePurchaseValue(val){
    }


    /** @type {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}  */
    get price(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['price'] : null, this.__metadata__['price']?.remoteType);
    }
    set price(val){
    }


    /** @type {string}  */
    get productFullName(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['productFullName'] : null, this.__metadata__['productFullName']?.remoteType);
    }
    set productFullName(val){
    }


    /** @type {BigDecimal}  */
    get purchaseValue(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['purchaseValue'] : null, this.__metadata__['purchaseValue']?.remoteType);
    }
    set purchaseValue(val){
    }


    /** @type {BigDecimal}  */
    get purchaseValueTotal(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['purchaseValueTotal'] : null, this.__metadata__['purchaseValueTotal']?.remoteType);
    }
    set purchaseValueTotal(val){
    }


    /** @type {number}  */
    get quantityRealization(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['quantityRealization'] : null, this.__metadata__['quantityRealization']?.remoteType);
    }
    set quantityRealization(val){
    }


    /** @type {BigDecimal}  */
    get sellingValue(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sellingValue'] : null, this.__metadata__['sellingValue']?.remoteType);
    }
    set sellingValue(val){
    }


    /** @type {BigDecimal}  */
    get sellingValueOnline(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sellingValueOnline'] : null, this.__metadata__['sellingValueOnline']?.remoteType);
    }
    set sellingValueOnline(val){
    }


    /** @type {BigDecimal}  */
    get sellingValueTotal(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['sellingValueTotal'] : null, this.__metadata__['sellingValueTotal']?.remoteType);
    }
    set sellingValueTotal(val){
    }


    /** @type {BigDecimal}  */
    get stockLevels(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['stockLevels'] : null, this.__metadata__['stockLevels']?.remoteType);
    }
    set stockLevels(val){
    }


    /** @type {number}  */
    get totalQuantity(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['totalQuantity'] : null, this.__metadata__['totalQuantity']?.remoteType);
    }
    set totalQuantity(val){
    }


    /** @type {number}  */
    get wMS(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['wMS'] : null, this.__metadata__['wMS']?.remoteType);
    }
    set wMS(val){
    }


    /** @type {boolean}  */
    get warningDateRequiredOnWarehouse(){
        return RpcClass.makeFieldInstance(this.__computed__ ? this.__computed__['warningDateRequiredOnWarehouse'] : null, this.__metadata__['warningDateRequiredOnWarehouse']?.remoteType);
    }
    set warningDateRequiredOnWarehouse(val){
    }


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withEID(val){
        this.EID = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    with__archived(val){
        this.__archived = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    with__familyId(val){
        this.__familyId = val;
        return this;
    };


    /**
     * @param val {boolean}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    with__hidden(val){
        this.__hidden = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    with__parent(val){
        this.__parent = val;
        return this;
    };


    /**
     * @param val {Date}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    with__versionDate(val){
        let rawValue = val;
        let v = val;
        v = new Date(rawValue)
        this.__versionDate = v;
        return this;
    };


    /**
     * @param val {Object.<string, *>}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    with_translations(val){
        this._translations = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withBaseProductId(val){
        this.baseProductId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getBaseProductIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Product', 'baseProductId', allowRemote); //  true 
    }

    /** @returns {String} */
        getBaseProductIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Product', 'baseProductId'); //  true 
    }

        /** @returns {Promise<Product>} */
    getBaseProductIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Product', 'baseProductId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withBudgetingPlannerId(val){
        this.budgetingPlannerId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getBudgetingPlannerIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.BudgetingPlanner', 'budgetingPlannerId', allowRemote); //  true 
    }

    /** @returns {String} */
        getBudgetingPlannerIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.BudgetingPlanner', 'budgetingPlannerId'); //  true 
    }

        /** @returns {Promise<BudgetingPlanner>} */
    getBudgetingPlannerIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.BudgetingPlanner', 'budgetingPlannerId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withCategoryId(val){
        this.categoryId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getCategoryIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Category', 'categoryId', allowRemote); //  true 
    }

    /** @returns {String} */
        getCategoryIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Category', 'categoryId'); //  true 
    }

        /** @returns {Promise<Category>} */
    getCategoryIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Category', 'categoryId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withColorVersionId(val){
        this.colorVersionId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getColorVersionIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ColorVersion', 'colorVersionId', allowRemote); //  true 
    }

    /** @returns {String} */
        getColorVersionIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ColorVersion', 'colorVersionId'); //  true 
    }

        /** @returns {Promise<ColorVersion>} */
    getColorVersionIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ColorVersion', 'colorVersionId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withCurrentSelectedRegion(val){
        this.currentSelectedRegion = val;
        return this;
    };


    /**
     * @param val {LocalDate}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withDateRequiredOnWarehouse(val){
        let rawValue = val;
        let v = val;
        v = new LocalDate(); v.value = rawValue;
        this.dateRequiredOnWarehouse = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withDefaultEAN(val){
        this.defaultEAN = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withId(val){
        this.id = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withMarginIPPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.marginIPPlanner = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withNetPricePlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.netPricePlanner = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withNotes(val){
        this.notes = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOnlineMarginPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.onlineMarginPlanner = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOnlinePurchaseValuePlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.onlinePurchaseValuePlanner = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOnlineQuantity(val){
        this.onlineQuantity = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOnlineQuantityPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.onlineQuantityPlanner = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOptimum2XL(val){
        this.optimum2XL = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOptimum3XL(val){
        this.optimum3XL = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOptimumL(val){
        this.optimumL = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOptimumM(val){
        this.optimumM = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOptimumS(val){
        this.optimumS = val;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withOptimumXL(val){
        this.optimumXL = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withPlanningId(val){
        this.planningId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getPlanningIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.PlanningProduct', 'planningId', allowRemote); //  true 
    }

    /** @returns {String} */
        getPlanningIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.PlanningProduct', 'planningId'); //  true 
    }

        /** @returns {Promise<PlanningProduct>} */
    getPlanningIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.PlanningProduct', 'planningId', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withPricePlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.pricePlanner = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withProductId(val){
        this.productId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getProductIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.ProductInSeason', 'productId', allowRemote); //  true 
    }

    /** @returns {String} */
        getProductIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.ProductInSeason', 'productId'); //  true 
    }

        /** @returns {Promise<ProductInSeason>} */
    getProductIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.ProductInSeason', 'productId', allowRemote); //  true 
    }

    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withPromotionalPrice(val){
        this.promotionalPrice = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withPurchaseValuePlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.purchaseValuePlanner = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withPurchaseValueTotalPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.purchaseValueTotalPlanner = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withQuantityPOS(val){
        this.quantityPOS = val;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withQuantityPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.quantityPlanner = v;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withRecordMetadata(val){
        this.recordMetadata = val;
        return this;
    };


    /**
     * @param val {module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withRetailPrice(val){
        this.retailPrice = val;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSalonCategory(val){
        this.salonCategory = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSalonCategoryLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.dictionaries.SalonCategory', 'salonCategory', allowRemote); //  true 
    }

    /** @returns {String} */
        getSalonCategoryStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.dictionaries.SalonCategory', 'salonCategory'); //  true 
    }

        /** @returns {Promise<SalonCategory>} */
    getSalonCategoryEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.dictionaries.SalonCategory', 'salonCategory', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSeasonId(val){
        this.seasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Season', 'seasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Season', 'seasonId'); //  true 
    }

        /** @returns {Promise<Season>} */
    getSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Season', 'seasonId', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSellingValueOnlinePlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.sellingValueOnlinePlanner = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSellingValuePlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.sellingValuePlanner = v;
        return this;
    };


    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSellingValueTotalPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.sellingValueTotalPlanner = v;
        return this;
    };


    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSubSeasonId(val){
        this.subSeasonId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSubSeasonIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.SubSeason', 'subSeasonId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSubSeasonIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.SubSeason', 'subSeasonId'); //  true 
    }

        /** @returns {Promise<SubSeason>} */
    getSubSeasonIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.SubSeason', 'subSeasonId', allowRemote); //  true 
    }

    /**
     * @param val {string}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withSupplierId(val){
        this.supplierId = val;
        return this;
    };

    /** @returns {Promise<String>} */
    getSupplierIdLabel(allowRemote=true){
        return this.__getFkLabel('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /** @returns {String} */
        getSupplierIdStaticLabel(){
        return this.__getFkStaticLabel('com.silkplm.model.plm.Suppliers', 'supplierId'); //  true 
    }

        /** @returns {Promise<Suppliers>} */
    getSupplierIdEntity(allowRemote=true){
        return this.__getFkEntity('com.silkplm.model.plm.Suppliers', 'supplierId', allowRemote); //  true 
    }

    /**
     * @param val {BigDecimal}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withTotalQuantityPlanner(val){
        let rawValue = val;
        let v = val;
        v = new BigDecimal(rawValue)
        this.totalQuantityPlanner = v;
        return this;
    };


    /**
     * @param val {number}
     * @returns {module:src/server/com/silkplm/model/plm/BudgetingPlannerPM.BudgetingPlannerPM}
     */
    withVersion(val){
        this.version = val;
        return this;
    };




    /**
    * @param {string[]?} fields
    * @returns {Promise<BudgetingPlannerPM>}
    */
    async save(fields){
        return this.__save(FULL_CLASS, fields);
    }

    async load(id=null){
        if(id == null){
            id = this.id;
        }
        let newVersion = await loadBudgetingPlannerPM(id);
        for(const k in newVersion){
            this[k] = newVersion[k];
        }
    }
    /**
     * @return {Promise}
     */
    async delete(){
        return Rpc.Forms.deleteEntity(FULL_CLASS, this.id);
    }
    /**
     * @param {*|string} replacementIdOrInst
     * @return {Promise}
     */
    async deleteWithReplacement(replacementIdOrInst){
        if(replacementIdOrInst.hasOwnProperty('id')){
            replacementIdOrInst = replacementIdOrInst.id;
        }
        return Rpc.Forms.deleteEntityWithReplacement(FULL_CLASS, this.id, replacementIdOrInst);
    }
    /**
     * CAN_DELETE | SUGGEST_REPLACEMENT | FORCE_REPLACEMENT | DELETE_RESTRICTED | DELETE_NOT_PERMITTED
     * @return {Promise<String>>}
     */
    async canDelete(){
        return Rpc.Forms.canDeleteEntity(FULL_CLASS, this.id);
    }

    /**
     * @param fieldName
     * @returns {Promise<FieldValidationResult>}
     */
    async validateField(fieldName){
        return Rpc.Forms.validateField(FULL_CLASS, fieldName, this[fieldName], this.id);
    }

    /**
     * @returns {Promise<InputValidationResult>}
     */
    async checkConstraints(){
        return Rpc.Forms.checkConstraints(FULL_CLASS, this);
    }
    /** @returns {Promise<String>}*/
    async getFkFieldLabel(fiendName, allowRemote=false) {
        if(fiendName === 'productIdProductIdPM'){
            return this.getProductIdProductIdPMLabel(allowRemote);
        }
        if(fiendName === 'budgetingPlannerIdPMResponsibleForTheGroup'){
            return this.getBudgetingPlannerIdPMResponsibleForTheGroupLabel(allowRemote);
        }
        if(fiendName === 'colorVersionIdColor'){
            return this.getColorVersionIdColorLabel(allowRemote);
        }
        if(fiendName === 'baseProductId'){
            return this.getBaseProductIdLabel(allowRemote);
        }
        if(fiendName === 'budgetingPlannerId'){
            return this.getBudgetingPlannerIdLabel(allowRemote);
        }
        if(fiendName === 'categoryId'){
            return this.getCategoryIdLabel(allowRemote);
        }
        if(fiendName === 'colorVersionId'){
            return this.getColorVersionIdLabel(allowRemote);
        }
        if(fiendName === 'planningId'){
            return this.getPlanningIdLabel(allowRemote);
        }
        if(fiendName === 'productId'){
            return this.getProductIdLabel(allowRemote);
        }
        if(fiendName === 'salonCategory'){
            return this.getSalonCategoryLabel(allowRemote);
        }
        if(fiendName === 'seasonId'){
            return this.getSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'subSeasonId'){
            return this.getSubSeasonIdLabel(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdLabel(allowRemote);
        }

        return '';
    }

    /** @returns {Promise<*>}*/
    async getFkFieldEntity(fiendName, allowRemote=false) {
        if(fiendName === 'baseProductId'){
            return this.getBaseProductIdEntity(allowRemote);
        }
        if(fiendName === 'budgetingPlannerId'){
            return this.getBudgetingPlannerIdEntity(allowRemote);
        }
        if(fiendName === 'categoryId'){
            return this.getCategoryIdEntity(allowRemote);
        }
        if(fiendName === 'colorVersionId'){
            return this.getColorVersionIdEntity(allowRemote);
        }
        if(fiendName === 'planningId'){
            return this.getPlanningIdEntity(allowRemote);
        }
        if(fiendName === 'productId'){
            return this.getProductIdEntity(allowRemote);
        }
        if(fiendName === 'salonCategory'){
            return this.getSalonCategoryEntity(allowRemote);
        }
        if(fiendName === 'seasonId'){
            return this.getSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'subSeasonId'){
            return this.getSubSeasonIdEntity(allowRemote);
        }
        if(fiendName === 'supplierId'){
            return this.getSupplierIdEntity(allowRemote);
        }
        return null;
    }


    /**
     * @param {string} externalSystemName
     * @returns {Promise<string>}
     */
    async externalId(externalSystemName){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, this.id, externalSystemName);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async loadByExternalId(externalSystemName, externalId){
    //clazzName, silkId, extSystem
        let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
        if(res.recordStatus !== "EXISTS"){
            throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
        }
        await this.load(res.silkId);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async bindExternalId(externalSystemName, externalId){
      //clazzName, extId, extSystem, silkId
      return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, this.id);
   }

    /**
     * @param {string} externalSystemName
     * @param {string} externalId
     * @returns {Promise<>}
     */
    async removeExternalId(externalSystemName, externalId){
        //clazzName, silkId, extSystem
        return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, this.id);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @returns {Promise<string>}
     */
    async readBoundValue(externalSystemName, keyName){
      let res = await Rpc.Integrations.readObjectData(FULL_CLASS, this.id, externalSystemName, keyName);
      return JSON.parse(res);
    }

    /**
     * @param {string} externalSystemName
     * @param {string} keyName
     * @param {Object} val
     * @returns {Promise<>}
     */
    async bindValue(externalSystemName, keyName, val){
      return Rpc.Integrations.storeObjectData(FULL_CLASS, externalSystemName, this.id, keyName, val);
    }

    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}

/**
 * @param {string} id
 * @param {boolean?} loadFkObjects
 * @returns {Promise<BudgetingPlannerPM>}
 */
async function loadBudgetingPlannerPM(id, loadFkObjects){
    if(loadFkObjects){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<BudgetingPlannerPM[]>}
 */
async function listBudgetingPlannerPM(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @param {string} id
 * @returns {Promise<string>}
 */
async function labelBudgetingPlannerPM(id){
    return Rpc.Forms.getEntityLabel(FULL_CLASS, id);
}
// STATICS --------------------------------------

/**
 * @param {string} id
 * @param {boolean?} loadDetails
 * @returns {Promise<BudgetingPlannerPM>}
 */
BudgetingPlannerPM.load = async function(id, loadDetails=false){
    if(loadDetails){
        return Rpc.Forms.getExtendedEntity(FULL_CLASS, id);
    }
    return Rpc.Forms.getEntity(FULL_CLASS, id);
}

/**
 * @returns {Promise<BudgetingPlannerPM[]>}
 */
BudgetingPlannerPM.list = async function(){
    return Rpc.Forms.listEntities(FULL_CLASS);
}

/**
 * @returns {Promise<BudgetingPlannerPM[]>}
 */
BudgetingPlannerPM.listExtended = async function(){
    return Rpc.Forms.listExtendedEntities(FULL_CLASS);
}

/**
 * @returns {Promise<BudgetingPlannerPM[]>}
 */
BudgetingPlannerPM.getRemoteClass = function(){
    return FULL_CLASS;
}

/**
 * @param {string} externalSystem
 * @param {string} extId
 * @param {boolean?} loadDetails
 * @returns {Promise<BudgetingPlannerPM>}
 */
BudgetingPlannerPM.loadByExternalId = async function(externalSystem, extId, loadDetails=false){

    let res = await Rpc.Integrations.externalIdToSilk(FULL_CLASS, extId, externalSystem);
    if(res.recordStatus !== "EXISTS"){
        throw new RpcNotFoundException({originalMessage:`Record status: ${res.recordStatus}`});
    }
    return BudgetingPlannerPM.load(res.silkId, loadDetails);
}


// INTEGRATIONS --------------------------------

/**
 * @param {string} externalSystemName
 * @param {string} silkId
 * @returns {Promise<IdMapping>}
 */
BudgetingPlannerPM.bindingFromSilkId = async function(externalSystemName, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.silkIdToExternalId(FULL_CLASS, silkId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<IdMapping>}
 */
BudgetingPlannerPM.bindingFromExternalId = async function(externalSystemName, externalId){
    //clazzName, silkId, extSystem
    return  Rpc.Integrations.externalIdToSilk(FULL_CLASS, externalId, externalSystemName);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @param {string} silkId
 * @returns {Promise<>}
 */
BudgetingPlannerPM.bindExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, extId, extSystem, silkId
    return Rpc.Integrations.setMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {string} externalSystemName
 * @param {string} externalId
 * @returns {Promise<>}
 */
BudgetingPlannerPM.removeExternalId = async function(externalSystemName, externalId, silkId){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, externalId, externalSystemName, silkId);
}

/**
 * @param {IdMapping} binding
 * @returns {Promise<>}
 */
BudgetingPlannerPM.removeExternalBinding = async function(binding){
    //clazzName, silkId, extSystem
    return Rpc.Integrations.clearMapping(FULL_CLASS, binding.externalId, binding.externalSystem, binding.silkId);
}



let metadata = {};
metadata['EID'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['__archived'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__familyId'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__hidden'] = {'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['__parent'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['__versionDate'] = {'remoteType' : 'java.time.Instant', 'jsType' : 'Date', 'mapped' : 'true'};
metadata['_translations'] = {'remoteType' : 'Object.<string, *>', 'jsType' : 'Object.<string, *>', 'mapped' : 'false'};
metadata['baseProductId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['budgetingPlannerId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['categoryId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['currentSelectedRegion'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['dateRequiredOnWarehouse'] = {'remoteType' : 'java.time.LocalDate', 'jsType' : 'LocalDate', 'mapped' : 'true'};
metadata['defaultEAN'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['id'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['marginIPPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['netPricePlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['notes'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['onlineMarginPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['onlinePurchaseValuePlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['onlineQuantity'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['onlineQuantityPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['optimum2XL'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['optimum3XL'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['optimumL'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['optimumM'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['optimumS'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['optimumXL'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['planningId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['pricePlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['productId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['promotionalPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['purchaseValuePlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['purchaseValueTotalPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['quantityPOS'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['quantityPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['recordMetadata'] = {'remoteType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'jsType' : 'module:src/server/com/silkplm/engine/entities/tracking/RecordMetadata.RecordMetadata', 'mapped' : 'false'};
metadata['retailPrice'] = {'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['salonCategory'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['seasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['sellingValueOnlinePlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['sellingValuePlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['sellingValueTotalPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['subSeasonId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['supplierId'] = {'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['totalQuantityPlanner'] = {'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['version'] = {'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['comment'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['margin'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['merchantsComputed'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['modelColorQuantityPlan'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['modelColorQuantityRealization'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['netPrice'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['netPricePLNWithTransport'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['numberOfOuters'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['onlinePurchaseValue'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['price'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'jsType' : 'module:src/server/com/silkplm/rpc/dto/DecimalWithCurrency.DecimalWithCurrency', 'mapped' : 'false'};
metadata['productFullName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['purchaseValue'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['purchaseValueTotal'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['quantityRealization'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['sellingValue'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['sellingValueOnline'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['sellingValueTotal'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['stockLevels'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['totalQuantity'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['wMS'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['warningDateRequiredOnWarehouse'] = {'computed' : true, 'remoteType' : 'boolean', 'jsType' : 'boolean', 'mapped' : 'false'};
metadata['planningIdCBM'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['productIdProductIdPM'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['budgetingPlannerIdPMResponsibleForTheGroup'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['colorVersionIdColor'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productIdProductIdDuty'] = {'computed' : true, 'remoteType' : 'java.math.BigDecimal', 'jsType' : 'BigDecimal', 'mapped' : 'true'};
metadata['productIdProductIdGallery'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'jsType' : 'module:src/server/com/silkplm/files/images/ImageGallery.ImageGallery', 'mapped' : 'false'};
metadata['productIdProductIdMerchants'] = {'computed' : true, 'remoteType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]', 'jsType' : 'module:src/server/com/silkplm/model/plm/ApplicationUserOnProductEmbedded.ApplicationUserOnProductEmbedded[]', 'mapped' : 'false'};
metadata['productIdProductIdName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productIdProductIdUnitName'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productIdProductIdNumberOfProduct'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['productIdProductIdQuantityInner'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['planningIdQuantityOuter'] = {'computed' : true, 'remoteType' : 'number', 'jsType' : 'number', 'mapped' : 'false'};
metadata['supplierIdSupplierCode'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};
metadata['productIdProductIdSupplierProductId'] = {'computed' : true, 'remoteType' : 'string', 'jsType' : 'string', 'mapped' : 'false'};

metadata.__type__ = 'com.silkplm.model.plm.BudgetingPlannerPM';
metadata.__type_short__ = 'BudgetingPlannerPM';
BudgetingPlannerPM.prototype.__metadata__ = metadata;

BudgetingPlannerPM.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/model/plm/BudgetingPlannerPM */
export default BudgetingPlannerPM

export { BudgetingPlannerPM , loadBudgetingPlannerPM, listBudgetingPlannerPM, labelBudgetingPlannerPM }
